import type { WebAppDraftStrategyType } from '@terra/shared-schemas-orchestrator';

export const isWebAppDraftStrategy = (
  value: string,
): value is WebAppDraftStrategyType =>
  value === 'PER_ORIGIN' || value === 'PER_APEX';

export const webAppStrategyTranslationKey = (
  strategy: WebAppDraftStrategyType,
): 'perOrigin' | 'perApex' =>
  strategy === 'PER_APEX' ? 'perApex' : 'perOrigin';
